import React, { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faExclamationCircle, faInfoCircle, faExclamationTriangle, faTimes } from "@fortawesome/free-solid-svg-icons";
import "./Toast.scss";

const typeIconMap = {
    success: faCheckCircle,
    error: faExclamationCircle,
    info: faInfoCircle,
    warning: faExclamationTriangle,
};

const typeClassMap = {
    success: "toast-success",
    error: "toast-error",
    info: "toast-info",
    warning: "toast-warning",
};

const Toast = ({ message, onClose, type = "info", duration = 3000, icon }) => {
    useEffect(() => {
        if (duration > 0) {
            const timer = setTimeout(onClose, duration);
            return () => clearTimeout(timer);
        }
    }, [onClose, duration]);

    const iconToShow = icon || typeIconMap[type] || faInfoCircle;
    const className = `toast ${typeClassMap[type] || "toast-info"}`;

    return (
        <div className={className} role="alert" aria-live="assertive">
            <span className="toast-icon">
                <FontAwesomeIcon icon={iconToShow} />
            </span>
            <span className="toast-message">{message}</span>
            <button className="toast-close" onClick={onClose} aria-label="Close notification">
                <FontAwesomeIcon icon={faTimes} />
            </button>
        </div>
    );
};

export { Toast };
